<div class="main-content">
  <div class="container-fluid p-0">
    <h2 class="pl-3 pt-3 mb-0 title">Mi Cuenta</h2>
    <div class="row">
      <div class="col-12 col-md-8">

        <!-- Datos Empresa -->
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">Datos Empresa</h3>
            <div class="row" *ngIf="!profile">
              <div class="col-md-12 p-2">
                Cargando...
              </div>
            </div>

            <div class="row" *ngIf="currentCompany && !loading">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-12 col-md-6 text-center d-flex justify-content-center align-items-center mb-3">
                    <ng-container *ngIf="currentCompany?.logo?.fileUrl"
                      class="d-flex justify-content-center items-center">
                      <img class="image-preview" [src]="currentCompany.logo?.fileUrl" />
                    </ng-container>
                    <ng-container *ngIf="!currentCompany.logo" class="d-flex justify-content-center align-items-center">
                      <a class="image-preview box-add-img cursor-pointer" (click)="openCompanyModal(currentCompany)">
                        <i class="material-icons" style="font-size: 8rem; color: white;">add</i>
                      </a>
                    </ng-container>
                  </div>
                  <div class="col-12 col-md-6 pull-right">
                    <div class="row">
                      <div class="col-6 col-md-12 pl-3 pl-md-0">
                        <h5><span class="data-header">Nombre:</span><br>
                          {{currentCompany.name}}</h5>
                      </div>
                      <div class="col-6 col-md-12 pl-3 pl-md-0">
                        <h5><span class="data-header">Pais:</span><br>
                          {{currentCompany.country?.name}}</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 col-md-12 pl-3 pl-md-0" *ngIf="currentCompany.phone">
                        <h5><span class="data-header">Telefono:</span><br>
                          {{currentCompany.phone}}</h5>
                      </div>
                      <div class="col-6 col-md-12 pl-3 pl-md-0" *ngIf="currentCompany.email">
                        <h5><span class="data-header">Email Empresa:</span><br>
                          {{currentCompany.email}}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 text-md-center">
                    <button mat-raised-button type="button" class="btn btn-manax p-2"
                      (click)="openCompanyModal(currentCompany)">
                      <i class="material-icons">construction</i> Configuración de empresa
                    </button>
                  </div>
                  <div class="col-6 pl-md-0">
                    <button mat-raised-button type="button" class="btn btn-manax p-2"
                      (click)="openCompanySettings(currentCompany)">
                      <i class="material-icons">tune</i> Preferencias
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Datos Usuario -->
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">Datos Usuario</h3>
            <div class="row" *ngIf="profile && currentCompany && !loading">
              <div class="col-12">
                <h5><span class="data-header">Email:</span><br>
                  {{profile.username}}</h5>
              </div>

              <div class="col-12">
                <h5 class="mb-0" class="data-header">Permisos Generales:</h5>
                <ul>
                  <li *ngFor="let role of profile.roles">
                    {{roleLabels[role.name || '']}}
                  </li>
                </ul>
              </div>

              <div class="col-12" *ngIf="currentCompany.isTrial">
                <h5><span class="data-header">Estado de Cuenta</span><br>
                  Trial</h5>
              </div>

            </div>

            <div class="row mt-2">
              <div class="col-12">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)='changePassword()'>
                  <i class="material-icons">lock_reset</i> Cambiar Mi Contraseña
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2 class="pl-3 pt-3 mb-0 title col-12">Preferencias</h2>

      <!-- Series de facturacion -->
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">Series de Facturacion</h3>
            <div class="row">
              <div class="table-striped col-12">
                <table class="table table-hover m-0 align-top">
                  <tbody>
                    <tr>
                      <!-- PC -->
                      <td class="d-none d-md-table-cell text-center font-weight-bold">Serie</td>
                      <td class="d-none d-md-table-cell text-center font-weight-bold">Nº Ultima Facturacion</td>
                      <!-- Mobile -->
                      <td class="d-table-cell d-md-none text-center font-weight-bold">Serie</td>
                      <td class="d-table-cell d-md-none text-center font-weight-bold">Nº Ultima Facturacion</td>
                    </tr>
                    <tr *ngFor="let counter of counters" class='cursor-pointer'>
                      <!-- PC -->
                      <td class="d-none d-md-table-cell text-center"
                        *ngIf="counter.reference_value?.serie && counter.id === 'billing_counter'">
                        {{counter.reference_value?.serie}}</td>
                      <td class="d-none d-md-table-cell text-center"
                        *ngIf="counter.reference_value?.serie && counter.id === 'billing_counter'">
                        {{counter.seq}}</td>
                      <!-- Mobile -->
                      <td class="d-table-cell d-md-none text-center" style="line-height: 14px;"
                        *ngIf="counter.reference_value?.serie && counter.id === 'billing_counter'">
                        <b>{{counter.reference_value?.serie}}</b><br>
                      </td>
                      <td class="d-table-cell d-md-none text-center"
                        *ngIf="counter.reference_value?.serie && counter.id === 'billing_counter'">
                        {{counter.seq}}</td>
                    </tr>

                    <tr *ngIf="loading">
                      <td colspan="10">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewCountersModal()">
                  <i class="material-icons">add</i> Crear nueva serie
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Forma de pago -->
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">Forma de pago</h3>
            <div class="row">
              <div class="table-striped col-12">
                <table class="table table-hover m-0 align-top">
                  <tbody>
                    <tr *ngFor="let paymentMet of paymentMethodTypesKeys" class='cursor-pointer'>

                      <td class="d-none d-md-table-cell text-center">
                        {{paymentMethodTypes[paymentMet]}}</td>

                      <td class="d-table-cell d-md-none text-center" style="line-height: 14px;">
                        <b>{{paymentMethodTypes[paymentMet]}}</b><br>
                      </td>
                    </tr>

                    <tr *ngIf="loading">
                      <td colspan="10">Cargando...</td>
                    </tr>


                  </tbody>
                </table>
              </div>
            </div>

            <div class="row mt-2">
              <!-- <div class="col-12">
                <button mat-raised-button type="button" class="btn btn-manax p-2"
                  (click)="openSettingModal('PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER')">
                  <i class="material-icons">add</i> Agregar/Modificar Numero tranferencia bancaria
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Nº para transferencia bancaria -->
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">N° de cuenta para transferencia bancaria</h3>
            <div class="row" *ngIf="profile && currentCompany && !loading && !newNtf">
              <div class="col-12">
                <h5><br>
                  {{paymentNumberTransfer || "-Sin definir-"}}</h5>
              </div>
            </div>
            <form *ngIf="form_ntf && newNtf" class="m-0" [formGroup]="form_ntf">
              <mat-form-field *ngIf="newNtf">
                <input matInput name="ntf" formControlName="ntf" style="height: 24px !important;">

              </mat-form-field>
            </form>

            <div class="row mt-2">
              <div class="col-12" *ngIf="!newNtf">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="newNtf = true">
                  <i class="material-icons">settings</i> Modificar numero
                </button>
              </div>
              <div class="col-12" *ngIf="newNtf">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="onSubmit_ntf()">
                  <i class="material-icons">settings</i> Guardar
                </button>
              </div>
            </div>

            <!-- <div class="row mt-2">
              <div class="col-12">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openSettingModal('PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER')">
                  <i class="material-icons">add</i> eeeee
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Términos y condiciones -->
      <div class="col-12 col-md-6">
        <div class="card">
          <div class="card-body">
            <h3 class="mt-0 subtitle">Términos y condiciones</h3>
            <div class="row" *ngIf="profile && currentCompany && !loading && !newTyc">
              <div class="col-12">
                <h5><br>
                  {{termAndCond || "-Sin definir-"}}</h5>
              </div>
            </div>
            <form *ngIf="form_tyc && newTyc" class="m-0" [formGroup]="form_tyc">
              <mat-form-field *ngIf="newTyc">
                <textarea matInput name="tyc" formControlName="tyc" style="height: 96px !important;"
                  [errorStateMatcher]="customErrorStateMatcher">
                </textarea>
                <mat-error *ngIf="form_tyc.get('tyc')?.invalid">
                  Términos y condiciones deben tener un largo menor a 200 caracteres
                </mat-error>
              </mat-form-field>
            </form>

            <div class="row mt-2">
              <div class="col-12" *ngIf="!newTyc">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="newTyc = true">
                  <i class="material-icons">settings</i> Modificar términos y condiciones
                </button>
              </div>
              <div class="col-12" *ngIf="newTyc">
                <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="onSubmit_tyc()">
                  <i class="material-icons">settings</i> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Manax -->
    <div class="col-12" *ngIf="isManax">
      <div class="card">
        <div class="card-body">
          <h4 class="mt-0 subtitle">Mi Cuenta</h4>

          <div class="row" *ngIf="!profile">
            <div class="col-md-12 p-2">
              Cargando...
            </div>
          </div>

          <div class="row" *ngIf="profile">
            <div class="col-md-7">
              <div class="p-2">
                <h4>Mis Empresas:</h4>
                <ul>
                  <li *ngFor="let company of profile.company">
                    {{company.name}}
                    <button mat-raised-button type="button" class="btn btn-link text-manax text-capitalize p-0 ml-4"
                      (click)="openCompanyModal(company)">
                      <i class="material-icons">construction</i> Configuración de empresa
                    </button>
                    <button mat-raised-button type="button" class="btn btn-link text-primary text-capitalize p-0 ml-4"
                      (click)="openCompanySettings(company)">
                      <i class="material-icons">tune</i> Preferencias
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-5">
              <div class="p-2">
                <h4>Permisos Generales:</h4>
                <ul>
                  <li *ngFor="let role of profile.roles">
                    {{roleLabels[role.name || '']}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <span class="pull-left">
                <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)='changePassword()'>
                  <i class="material-icons">lock_reset</i> Cambiar Mi Contraseña
                </button>
              </span>
              <span class="pull-right">
                <!--button mat-raised-button type="button" class="btn btn-outline-danger p-2" (click)='disableUser()'>
                    <i class="material-icons">person_off</i> Deshabilitar Mi Usuario
                  </button-->
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>